// extracted by mini-css-extract-plugin
export var addButton = "_t-g";
export var cartCardSlider = "_t-c";
export var cartContainer = "_t-17";
export var cartPreview = "_t-16";
export var cartTotal = "_t-1c";
export var chartContainer = "_t-1u";
export var chartLoading = "_t-1v";
export var checkoutButton = "_t-1i";
export var checkoutButtonContainer = "_t-1b";
export var checkoutContainer = "_t-1k";
export var checkoutPreview = "_t-1j";
export var coveragePreview = "_t-z";
export var dark = "_t-15";
export var editorStyleIcon = "_t-w";
export var errorText = "_t-1s";
export var fakeCheckoutCheckbox = "_t-1q";
export var fakeCheckoutContainer = "_t-1m";
export var fakeCheckoutImage = "_t-1n";
export var fakeCheckoutTextContainer = "_t-1o";
export var fakeCheckoutTitle = "_t-1p";
export var fakeProduct = "_t-1d";
export var fakeProductImage = "_t-1f";
export var fakeProductInfo = "_t-1g";
export var fakeProductPrice = "_t-1h";
export var fakeRedoToggle = "_t-1e";
export var fullCartContainer = "_t-19";
export var fullCartHeader = "_t-18";
export var fullWidth = "_t-0";
export var generalSettingsToggle = "_t-f";
export var hoverable = "_t-x";
export var icon = "_t-1";
export var iconButtonContainer = "_t-1t";
export var light = "_t-13";
export var medium = "_t-14";
export var modalDescription = "_t-l";
export var modalLeftButton = "_t-k";
export var navigateIcon = "_t-y";
export var newSplitModal = "_t-j";
export var payNowButton = "_t-1l";
export var previewLink = "_t-2";
export var previewStyleSelector = "_t-10";
export var previewStyleSelectorSizer = "_t-11";
export var pricingSettingBlock = "_t-1r";
export var quarterCartContainer = "_t-1a";
export var richTextEditor = "_t-u";
export var richTextLabel = "_t-v";
export var selected = "_t-t";
export var selectedSplitType = "_t-p";
export var sidebarContent = "_t-9";
export var sidebarContentSection = "_t-a";
export var sidebarPaddedRow = "_t-d";
export var sidebarSectionHeader = "_t-7";
export var sidebarSectionTitle = "_t-8";
export var sidebarSettingRow = "_t-b";
export var sidebarStyleSelector = "_t-e";
export var skeletonBlock = "_t-12";
export var splitContent = "_t-q";
export var splitContentContainer = "_t-5";
export var splitFooterContainer = "_t-r";
export var splitFormActions = "_t-i";
export var splitHeaderContainer = "_t-h";
export var splitName = "_t-3";
export var splitPage = "_t-4";
export var splitSidebarContainer = "_t-6";
export var splitTypeContainer = "_t-m";
export var splitTypeDescription = "_t-o";
export var splitTypeSelection = "_t-n";
export var treatmentNameButton = "_t-s";